import moment from 'moment'

export function formatDepDataNasc(d) {
  if (!d) return '—'
  try {
    if (moment.isMoment(d)) return d.format('DD/MM/YYYY')
    return moment(d).format('DD/MM/YYYY')
  } catch {
    return '—'
  }
}
